// Translations
import message from '../sections/message/translations/tr'

// Translation: Error > Landing (Turkish)
export default Object.freeze({
	sections: { message }
})
